// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-crud-table-dialog .MuiPaper-root{width:100%}`, "",{"version":3,"sources":["webpack://./../../shared/components/rhyme-component-library/src/components/SimpleCrudTable/styles.scss"],"names":[],"mappings":"AACE,yCACE,UAAA","sourcesContent":[".simple-crud-table-dialog {\r\n  .MuiPaper-root {\r\n    width: 100%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
